export { default } from './forEachRight.js'



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/eachRight.js
// module id = 380
// module chunks = 0